import { WbSpinner } from "@workbench/react";

interface Props {
  ariaLabel?: string;
}

export default function LoadingSpinner({ ariaLabel = "Loading..." }: Props) {
  return (
    <div className="loading-spinner-center">
      <span role="status" aria-label={ariaLabel}>
        <WbSpinner size="l" />
      </span>
      <span className="loading-spinner-label" aria-hidden="true">
        Loading...
      </span>
    </div>
  );
}
